import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FaqAccordion({ faqs, testidPrefix = "faq" }) {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid={`${testidPrefix}-accordion`}>
      {faqs.map((f, i) => (
        <AccordionItem key={i} value={`item-${i}`} className="border-slate-200">
          <AccordionTrigger data-testid={`${testidPrefix}-trigger-${i}`}
                            className="text-left font-heading font-semibold text-slate-900 hover:text-royal hover:no-underline py-4">
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="text-sm text-slate-600 leading-relaxed pb-4">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
